import FirstPartActiveIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/FirstPartActive.svg?react';
import SecondPartActiveIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/SecondPartActive.svg?react';
import SecondPartInActiveIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/SecondPartInactive.svg?react';
import FirstPartInActiveIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/FirstPartInactive.svg?react';
import { StepType } from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper.type';
import { ADJUSTER_REPORT_BODY_DAMAGE_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
export const BodyInformationStepperData: StepType[] = [
  {
    label: 'قسمت اول',
    icon: <FirstPartInActiveIcon />,
    activeIcon: <FirstPartActiveIcon />,
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.VEHICLE_INFORMATION.EDIT
      .base,
  },
  {
    label: 'قسمت دوم',
    icon: <SecondPartInActiveIcon />,
    activeIcon: <SecondPartActiveIcon />,
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.VEHICLE_INFORMATION.EDIT
      .partTwo,
  },
];
